module.exports = __webpack_public_path__ + "static/media/prenda5-min.15c192aa.jpg";